import { swRequest } from "@sourcewhale/core";

export const logNote = (body) =>
  swRequest({
    path: "/api/notes/save",
    method: "POST",
    body,
  });
